import "./styles/index.css";

import ReactDOM from "react-dom/client";
import { Provider as ReduxProvider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";

import { AlfredChatPanel } from "@/components";
import {
    AlfredAgentProvider,
    AlfredChatProvider,
    AuthProvider,
    NetworkProvider,
    PostHogProvider,
    ThemeProvider,
} from "@/providers";
import { persistor, store } from "@/redux/store";

import { App } from "./App";

ReactDOM.createRoot(document.getElementById("root")!).render(
    <BrowserRouter>
        <ReduxProvider store={store}>
            <PersistGate
                loading={null}
                persistor={persistor}
            >
                <ThemeProvider
                    defaultTheme="light"
                    storageKey="vite-ui-theme"
                >
                    <PostHogProvider>
                        <NetworkProvider>
                            <AuthProvider>
                                <AlfredChatProvider>
                                    <AlfredAgentProvider>
                                        <App />
                                        <AlfredChatPanel />
                                    </AlfredAgentProvider>
                                </AlfredChatProvider>
                            </AuthProvider>
                        </NetworkProvider>
                    </PostHogProvider>
                </ThemeProvider>
            </PersistGate>
        </ReduxProvider>
    </BrowserRouter>,
);
